import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import classNames from "classnames";
import { LoadingOutlined } from "@ant-design/icons";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { Image, Spin } from "antd";
import { SepIcon } from "svgIcon";
import HomeImage from "assets/images/homejpg.jpg";
import bannerBg from "assets/images/bannerBg.png";
import BackgroundVideo from '../../ECBasic/ECHeroSectionComponent/BackgroundVideo';
import {
    getMerchantAddress,
    getMerchantSetting,
    getMerchantPages,
} from "apiServices/app";
import { CryptoPassword, encryptedText } from "utils/crypto";
import { baseImageURL, siteRecaptchaKey } from "utils/env";
import {
    ExclusiveFlow,
    selectedChainIcon,
    toastMessage,
    useGlobalMerchant
} from 'utils/helper';
import MSubRoutesComponent from 'components/MerchantSubRoutes/MSubRoutesComponent';
import ECProductComponent from "components/Ecommerce/ECProductComponent";
import ECEHeaderComponent from '../ECEHeaderComponent';
import ECAddressWrapperComponent from '../../ECAddressWrapperComponent';
import { useStyles } from './style';

const ECExclusiveComponent = () => {
    const { globalMerchantId, ecommerceContent, isEndsWithSlash } = useGlobalMerchant();
    const [pagesContent, setPagesContent] = useState<any>({});
    const [merchantContent, setMerchantContent] = useState<any>({});
    const [chainList, setChainList] = useState<any>([]);
    const [showShippingLayout, setShowShippingLayout] = useState(false);
    const [showSideBasket, setShowSideBasket] = useState(false);
    const classes = useStyles();

    function getFileType(filePath: string): "image" | "video" {
        const isVideo = filePath.toLowerCase().endsWith(".mp4");
        return isVideo ? "video" : "image";
    }

    const manageBgDetails = (getPath: any) => {
        if (getPath == null) {
            return <Image src={HomeImage} alt="background image" preview={false} />;
        } else {
            const fileType = getFileType(getPath);
            if (fileType === "image") {
                return <Image src={`${baseImageURL}${getPath}`} alt="background image" preview={false} />
            } else {
                const videoSource = `${baseImageURL}${getPath}`;
                return <BackgroundVideo videoSource={videoSource}></BackgroundVideo>;
            }
        }
    };

    const renderLogoIcon = () => {
        return (
            <>
                {Object.keys(merchantContent).length > 0 && (
                    <Image
                        src={merchantContent.logo_path !== null ? `${baseImageURL}${merchantContent.logo_path}` : bannerBg}
                        alt="profile Picture"
                        preview={false}
                    />
                )}
            </>
        )
    }

    const onGetMerchantAddress = (getMerchantId: any) => {
        try {
            getMerchantAddress(getMerchantId)
                .then((response) => {
                    const responseData = response.data || response;
                    if (responseData.length > 0) {
                        const activeNetworks = responseData.filter((network: any) => network.is_active === 1);
                        setChainList(activeNetworks.reverse());
                    } else {
                        toastMessage("You don't have blockchain profile");
                    }
                })
                .catch((error) => { console.log(error); });
        } catch (error: any) { }
    };

    const onGetMerchantPages = (getMerchantKey: any) => {
        try {
            getMerchantPages(getMerchantKey)
                .then((response) => {
                    const responseData = response.data || response;
                    responseData !== null && responseData.success !== false && setPagesContent(responseData);
                })
                .catch((error) => { console.log(error); });
        } catch (error: any) { }
    }

    const onGetMerchantDetails = (getUserKey: any) => {
        try {
            getMerchantSetting(getUserKey)
                .then((response) => {
                    const responseData = response.data || response;
                    if (responseData !== null && responseData.success !== false) {
                        if (responseData && responseData.success == false) {
                            toastMessage("You dont have any profile");
                        } else {
                            onGetMerchantPages(responseData.merchant_id);
                            onGetMerchantAddress(responseData.merchant_id);
                            setMerchantContent(responseData);
                            localStorage.setItem("ec-email", encryptedText(CryptoPassword, responseData.merchant_email));
                        }
                    }
                })
                .catch((error) => { console.log(error); });
        } catch (error: any) { }
    };


    useEffect(() => { onGetMerchantDetails(globalMerchantId); }, []);

    return (
        <>
            {Object.keys(merchantContent).length == 0 ? (
                <div className="loaderCenterWrapper">
                    <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
                </div>
            ) : (
                <div className={classNames(classes.ecExclusiveWrapper)}>
                    <ToastContainer />
                    <div className='topWrapper'>  <p>{ecommerceContent.head_title}</p> </div>
                    <div className="container">
                        <GoogleReCaptchaProvider reCaptchaKey={siteRecaptchaKey}>
                            <ECEHeaderComponent
                                renderLogoIcon={renderLogoIcon}
                                showShippingLayout={showShippingLayout}
                                setShowSideBasket={setShowSideBasket}
                                showSideBasket={showSideBasket}
                                setShowShippingLayout={setShowShippingLayout}
                                ecommerceContent={ecommerceContent}
                                isEndsWithSlash={isEndsWithSlash}
                                pagesContent={pagesContent}
                            />
                        </GoogleReCaptchaProvider>
                        {isEndsWithSlash && <MSubRoutesComponent contentType={"pages"} pagesContent={pagesContent} />}
                        {!isEndsWithSlash && (
                            <>
                                {showShippingLayout ? (
                                    <ECAddressWrapperComponent flowName={ExclusiveFlow} setShowShippingLayout={setShowShippingLayout} />
                                ) : (
                                    <>
                                        <div className="bannerSection">
                                            <div className="bBg">
                                                {manageBgDetails(ecommerceContent.ecom_video_link)}
                                            </div>
                                            <div className="bContent">
                                                <div className="bHeader dFlex justifyCenter">
                                                    <div className="bLogo dFlex justifyCenter alignCenter">
                                                        <div>{renderLogoIcon()}</div>
                                                    </div>
                                                </div>
                                                <div className="bBody">
                                                    <h2>{ecommerceContent.ecom_title}</h2>
                                                    <p>{ecommerceContent.ecom_des}</p>
                                                </div>
                                                <div className="seperator dFlex alignCenter justifyCenter gap10">
                                                    <div className="sepLine"></div>
                                                    <div className="sepIcon"><SepIcon /></div>
                                                    <div className="sepLine"></div>
                                                </div>
                                                <div className="bFooter dFlex justifyCenter alignCenter gap10 flexCol">
                                                    <p>supported chains</p>
                                                    <div className="blockchains alignCenter dFlex justifyCenter gap10">
                                                        {chainList && chainList.length > 0 && (
                                                            chainList.map((item: any, index: number) => (
                                                                <span key={index}>
                                                                    {selectedChainIcon(item.blockchain_name)}
                                                                </span>
                                                            ))
                                                        )}
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <ECProductComponent />
                                    </>
                                )}
                            </>
                        )}
                        <div className="exfooterWrapper dFlex flexCol justifyCenter alignCenter">
                            <div className="footerLogo dFlex justifyCenter alignCenter">
                                <div>{renderLogoIcon()}</div>
                            </div>
                            <p className="textCenter">{ecommerceContent.foot_title}</p>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default ECExclusiveComponent